import TomSelect from 'tom-select/dist/js/tom-select.base.js';
import TomSelect_remove_button from 'tom-select/dist/js/plugins/remove_button.js';

TomSelect.define('remove_button', TomSelect_remove_button);

export function init(elementQuerySelector, teamId, valueField, labelField, searchField) {
  new TomSelect(elementQuerySelector, {
    valueField: valueField,
    labelField: labelField,
    searchField: searchField,
    plugins: ['remove_button'],
    openOnFocus: false,
    load: function (query, callback) {

      let url = `/admin/team/${teamId}/books/${encodeURIComponent(query)}`;
      fetch(url, {
        headers: {
          "Content-Type": "application/json",
          "Accept": "application/json"
        }
      })
        .then(response => response.json())
        .then(json => {
          callback(json);
        }).catch(() => {
        callback();
      });

    }
  });
}
